import { render, staticRenderFns } from "./usuario.vue?vue&type=template&id=47c8f470"
import script from "./usuario.vue?vue&type=script&lang=js"
export * from "./usuario.vue?vue&type=script&lang=js"
import style0 from "./usuario.vue?vue&type=style&index=0&id=47c8f470&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports